export default __webpack_public_path__ + "static/media/640_private01-en-web.46dd0e13.png";